import css from 'styled-jsx/css';


export default css`
  .fake-devices {
    background-color: white;
    z-index: 26;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin-top:20px;
    display: flex;
    flex-direction: row;
    width: 100%;
    .productsContainer {
      width: 100%;
    }
    &--filter {
      width: 100%;
    }
    &--main {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
      grid-gap: 20px;
    }
    &--header {
      display: flex;
      align-items:center;
      justify-content: space-between;
      margin-bottom:10px;
    }
  }
  @media (max-width: 1920px) {
    .fake-devices {
      &--filter {
        max-width: 220px;
      }
      &--main {
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      }
    }
  }
  :global(.display-desktop) {
    display:block;
  }
  :global(.display-mobile) {
    display:none;
  }

  @media (max-width: 968px) {
  
    .fake-devices {
      margin-top:3px;
      flex-direction: row;
      flex-direction: column;
      &--filter {
        width: 100%;
        max-width:100%
      }
      &--header {
        padding-left:0px;
      }
      &--main {
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      }
    }

    :global(.display-desktop) {
      display:none;
    }

    :global(.display-mobile) {
      display:block;
    }
  }

  @media (max-width: 480px) {
    .fake-devices {
      &--main {
        grid-gap: 10px;
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
      }
    }
  }
`;
